import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["prompt-ddown", {error: $props.required && $options.empty}])
  }, [
    _createVNode(_component_el_autocomplete, {
      ref: "el_autocomplete",
      modelValue: $data.el_value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.el_value) = $event)),
      placeholder: "Select prompt",
      teleported: false,
      "fetch-suggestions": $options.loadAsync,
      "value-key": "label",
      "fit-input-width": "",
      onSelect: $options.onSelect,
      onFocus: $options.onFocus,
      onBlur: $options.onBlur
    }, null, 8 /* PROPS */, ["modelValue", "fetch-suggestions", "onSelect", "onFocus", "onBlur"])
  ], 2 /* CLASS */))
}